import { bootstrapPostHog } from 'app/utils/postHog';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const PostHogBootstrap = () => {
  const featureFlags = useSelector(state => state.common.featureFlags);
  const featureFlagLoading = useSelector(
    state => state.common.featureFlagLoading
  );

  useEffect(() => {
    if (featureFlagLoading || !featureFlags) {
      return;
    }
    if (featureFlags.shouldDisableUserActivityTracking) {
      return;
    }
    bootstrapPostHog();
  }, [featureFlagLoading, featureFlags]);

  return null;
};

export default PostHogBootstrap;
